import { Dispatch } from 'react';

import {
    Action, ActionWithoutPayload
} from '../../types/common.types';

export const FETCH_REQUEST = 'FETCH_REQUEST';

export const FETCH_LOAD = 'FETCH_LOAD';

export const FETCH_SUCCESS = 'FETCH_SUCCESS';

export const FETCH_FAILURE = 'FETCH_FAILURE';

export const FETCH_CLEAR = 'FETCH_CLEAR';

export type FetchState<TData = any> = {
    data: null | TData
    isLoading: boolean
    isError: boolean
    isSuccess: boolean
    error: any | null
};

export type FetchRequestAction<TData=any> = Action<
    typeof FETCH_REQUEST,
    FetchRequestInitPayload<TData>
>;

export type FetchRequestInitPayloadBase<TData, TState> = {
    // name used as a prefix to actions
    name: string
    // a hook to transform the data value resolved by the fetch request
    // by default it assumes its json with a standard response.json() call
    transformResponse?: (data: any) => Promise<TData>
    // a hook to transform the fetch init options before calling fetch(url, init)
    transformInit?: (options: TransformInitOptions<TState>) => RequestInit
} & RequestInit;

export type FetchRequestInitPayload<TData = any, TState = any> =
    | {
    // the absolute url of the fetch(url) api
    url: string
} & FetchRequestInitPayloadBase<TData, TState>
    | {
    // a hook to resolve the absolute url of the fetch(url) api with access to app state
    resolveUrl: (state: TState) => string
} & FetchRequestInitPayloadBase<TData, TState>;

// The hook to transform the fetch init options before calling fetch(url, init)
export type TransformInitOptions<TState = any> = {
    state: TState
    init: RequestInit
    dispatch: Dispatch<any>
};

export type FetchSuccessAction<TData = any> = {
    type: string
    payload: { data: TData }
    meta: { response: Response }
};

export type FetchFailureAction = {
    type: string
    payload: { error: any }
    meta: { init: RequestInit }
};

export type FetchInitAction = ActionWithoutPayload;

export type FetchClearAction = ActionWithoutPayload;

export type FetchActions =
    | FetchFailureAction
    | FetchRequestAction
    | FetchSuccessAction
    | FetchInitAction
    | FetchClearAction;

export type FetchErrorPayload = {
    message: string
    code: number
    status?: number
    originalError: any
};
